module.exports = __webpack_public_path__ + "c8bd73e51a06ae2d26379699a63292e3.pdf";